import React from "react";
import { Helmet } from "react-helmet";

const SEO = ({ title = "Techify", description = "Techify Content" }) => {
  return (
    <Helmet>
      <html lang="en" />
      <title>{title}</title>
      <meta name="description" content={description} />
    </Helmet>
  );
};

export default SEO;
